import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '@modules/shell/services/spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {
  showSpinner: boolean = false;

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit(): void {
    this.spinnerService.loading.subscribe((result) => {
      this.showSpinner = result;
    });
  }
}
